import { render, staticRenderFns } from "./formVehicle.vue?vue&type=template&id=4d62ffdd&scoped=true"
import script from "./formVehicle.vue?vue&type=script&lang=js"
export * from "./formVehicle.vue?vue&type=script&lang=js"
import style0 from "./formVehicle.vue?vue&type=style&index=0&id=4d62ffdd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62ffdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d62ffdd')) {
      api.createRecord('4d62ffdd', component.options)
    } else {
      api.reload('4d62ffdd', component.options)
    }
    module.hot.accept("./formVehicle.vue?vue&type=template&id=4d62ffdd&scoped=true", function () {
      api.rerender('4d62ffdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/order/components/form/steps/formVehicle.vue"
export default component.exports